import React from 'react';
import { Typography, Col, Row } from 'antd';

import Bloco from '../Bloco';
import colors from '../../styles/colors';
import * as S from './styles';

const { Title } = Typography;

export function SubHeader({ title, icon, action }) {
  return (
    <S.SubHeaderPage>
      <Bloco>
        <Row
          style={{
            padding: '0px',
          }}
          justify="space-between"
          align="middle"
        >
          <Col
            style={{
              flexDirection: 'column',
            }}
          >
            <Col>
              <Title color={colors.blue} level={2}>
                {title || ''}
              </Title>
            </Col>
          </Col>
          <Col
            style={{
              padding: '0 29px 0 0',
            }}
          >
            {action && (
              <S.BtnAction icon={icon} type="primary" onClick={action}>
                Iniciar atendimento
              </S.BtnAction>
            )}
          </Col>
        </Row>
      </Bloco>
    </S.SubHeaderPage>
  );
}
